import React from 'react';
import {  Modal } from 'react-bootstrap';

const DeleteModal = ( { show, handleClose, handleDelete, message } ) =>
{

	return (
		<Modal
			show={show}
			onHide={handleClose}
			backdrop="static"
			keyboard={false}
			dialogClassName="modal-dialog-centered m-auto">
			<Modal.Header className="flex-column">
				<Modal.Title className="modal-title" id="deleteModalLabel" style={{
					"marginTop" : "20px",
					"direction" : "rtl"
				}}>پاک کردن</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<p style={{ "direction" : "rtl" }}>
					آیا می‌خواهید <strong style={{
						"fontSize" : "20px",
						"color" : "red"
				}}>{message}</strong> را پاک کنید؟
				</p>
			</Modal.Body>
			<Modal.Footer className="justify-content-center">
				<button type="button" className="btn btn-modal" onClick={handleClose}>خیر</button>
				<button type="button" className="btn btn-modal" onClick={handleDelete}>بله</button>
			</Modal.Footer>
		</Modal>
	);
};

export default DeleteModal;
